import * as React from 'react'

import Done     from '@material-ui/icons/Done'
import Schedule from '@material-ui/icons/Schedule'

import { success }       from '../theme'

const completionStateIconMap = {
  done:      <Done nativeColor={success.main} />,
  scheduled: <Schedule nativeColor={success.main} />,
  pending:   <Schedule nativeColor={'gray'} />,
}

export default completionStateIconMap



// WEBPACK FOOTER //
// ./src/project-utils/completion-state-icon-map.tsx